<template>
  <div id="spMenu" class="spMenuDefault" :class="{ modal: openDialog }" style="text-align: left;">
    <div class="spMenuHead">
      <div class="spMenuHeadLogo">
        <img class="" src="/img/sPmenuTitle.png" srcset="/img/sPmenuTitle@2x.png 2x" alt="東京カメラ部2020写真展 Online Exhibition「それでも世界は美しい。 - This Cruel Yet Beloved World -" />
      </div><!-- /spMenuHeadLogo-->
      <div class="spMenuHeadBtn close">
        <a href="javascript:void(0);" @click="close"><i></i><i></i><i></i></a>
      </div><!-- /spMenuHeadBtn-->
    </div><!-- /spMenuHead-->
    <nav class="spMenuBody">
      <a href="#" onclick=""><div class="spMenuCate cateTop spMenuCateLink">
        <a href="javascript:void(0);" @click="link('/')"><p>トップページ</p></a>
      </div></a>
      <div class="spMenuCate spMenuCateArtWork" :class="{ open: isTcc10SenOpen }">
        <a href="javascript:void(0);" @click="openMenu('tcc10sen')"><p>作品展示：東京カメラ部10選</p></a>
        <div class="menuWrapper">
          <ul :class="{ menuOpen: isTcc10SenOpen, menuClose: !isTcc10SenOpen }">
            <a href="javascript:void(0);" @click="link('/artworks/Tcc10Sen')"><li>東京カメラ部10選トップ</li></a>
            <a href="javascript:void(0);" @click="link('/artworks/Tcc10Sen2019/201901')"><li>10選2019</li></a>
            <a href="javascript:void(0);" @click="link('/artworks/Tcc10Sen2018/201801')"><li>10選2018</li></a>
            <a href="javascript:void(0);" @click="link('/artworks/Tcc10Sen2017/201701')"><li>10選2017</li></a>
            <a href="javascript:void(0);" @click="link('/artworks/Tcc10Sen2016/201601')"><li>10選2016</li></a>
            <a href="javascript:void(0);" @click="link('/artworks/Tcc10Sen2015/201501')"><li>10選2015</li></a>
            <a href="javascript:void(0);" @click="link('/artworks/Tcc10Sen2014/201401')"><li>10選2014</li></a>
            <a href="javascript:void(0);" @click="link('/artworks/Tcc10Sen2013/201302')"><li>10選2013</li></a>
            <a href="javascript:void(0);" @click="link('/artworks/Tcc10Sen2012/201201')"><li>10選2012</li></a>
          </ul>
        </div>
      </div>

      <div class="spMenuCate spMenuCateArtWork" :class="{ open: isJapan100ViewsOpen }">
        <a href="javascript:void(0);" @click="openMenu('japan100Views')"><p>作品展示：日本写真100景</p></a>
        <div class="menuWrapper">
          <ul :class="{ menuOpen: isJapan100ViewsOpen, menuClose: !isJapan100ViewsOpen }">
            <a href="javascript:void(0);" @click="link('/artworks/Japan100Views')"><li>日本写真100景トップ</li></a>
            <a href="javascript:void(0);" @click="link('/artworks/Japan100Views/100001')"><li>北海道</li></a>
            <a href="javascript:void(0);" @click="link('/artworks/Japan100Views/100003')"><li>東北</li></a>
            <a href="javascript:void(0);" @click="link('/artworks/Japan100Views/100015')"><li>関東</li></a>
            <a href="javascript:void(0);" @click="link('/artworks/Japan100Views/100030')"><li>中部</li></a>
            <a href="javascript:void(0);" @click="link('/artworks/Japan100Views/100051')"><li>近畿</li></a>
            <a href="javascript:void(0);" @click="link('/artworks/Japan100Views/100066')"><li>中国</li></a>
            <a href="javascript:void(0);" @click="link('/artworks/Japan100Views/100076')"><li>四国</li></a>
            <a href="javascript:void(0);" @click="link('/artworks/Japan100Views/100084')"><li>九州</li></a>
            <a href="javascript:void(0);" @click="link('/artworks/Japan100Views/100099')"><li>沖縄</li></a>
            <a href="javascript:void(0);" @click="link('/artworks/Japan100Views/100101')"><li>海外</li></a>
          </ul>
        </div>
      </div>

      <div class="spMenuCate spMenuCateArtWork" :class="{ open: isMyPreciousOpen }">
        <a href="javascript:void(0);" @click="openMenu('myPrecious')"><p>作品展示："My Precious" Photo Contest</p></a>
        <div class="menuWrapper">
          <ul :class="{ menuOpen: isMyPreciousOpen, menuClose: !isMyPreciousOpen }">
            <a href="javascript:void(0);" @click="link('/artworks/MyPrecious')"><li>"My Precious" Photo Contestトップ</li></a>
            <a href="javascript:void(0);" @click="link('/artworks/MyPrecious/200004')"><li>「大切なあの人」部門</li></a>
            <a href="javascript:void(0);" @click="link('/artworks/MyPrecious/200003')"><li>「愛おしい生き物」部門</li></a>
          </ul>
        </div>
      </div>

      <a href="#" onclick=""><div class="spMenuCate spMenuCateLink">
        <a href="javascript:void(0);" @click="link('/exhibitors')"><p>作品展示：展示者一覧</p></a>
      </div></a>

      <div class="spMenuCate" :class="{ open: isSpecialsOpen }">
        <a href="javascript:void(0);" @click="openMenu('specials')"><p>特別展示</p></a>
        <div class="menuWrapper">
          <ul :class="{ menuOpen: isSpecialsOpen, menuClose: !isSpecialsOpen }">
            <template v-if="!isDemo()">
              <a v-for="spcecialExhibition in this.specialExhibitions" href="javascript:void(0);" @click="link('/specials/' + spcecialExhibition.id)" :key="spcecialExhibition.id">
                <li>{{spcecialExhibition.name}}</li>
              </a>
            </template>
          </ul>
        </div>
      </div>
      <div class="spMenuCate" :class="{ open: isTalkshowsOpen }">
        <a href="javascript:void(0);" @click="openMenu('talkshows')"><p>オンライントークショー</p></a>
        <div class="menuWrapper">
          <ul :class="{ menuOpen: isTalkshowsOpen, menuClose: !isTalkshowsOpen }">
            <a href="javascript:void(0);" @click="link('/talkshows')"><li>トークショーアーカイブ動画</li></a>
            <a href="javascript:void(0);" @click="link('/talkshows/report_nikon')"><li>トークショーレポート：ニコンイメージングジャパン</li></a>
            <a href="javascript:void(0);" @click="link('/talkshows/report_fujifilm')"><li>トークショーレポート：富士フイルム株式会社</li></a>
            <a href="javascript:void(0);" @click="link('/talkshows/report_raytrek')"><li>トークショーレポート：株式会社サードウェーブ</li></a>
          </ul>
        </div>
      </div>
      <div class="spMenuCate" :class="{ open: isPhotobookOpen }">
        <a href="javascript:void(0);" @click="openMenu('photobooks')"><p>公式写真集</p></a>
        <div class="menuWrapper">
          <ul :class="{ menuOpen: isPhotobookOpen, menuClose: !isPhotobookOpen }">
            <a href="javascript:void(0);" @click="link('/photobook')"><li>公式写真集の紹介</li></a>
            <a href="javascript:void(0);" @click="link('/photobook/talkshow')"><li>発売記念オンライントークショー</li></a>
            <a href="javascript:void(0);" @click="link('/photobook/exhibition')"><li>10選2019作品プリント展示</li></a>
          </ul>
        </div>
      </div>
      <a href="#" onclick=""><div class="spMenuCate spMenuCateLink">
        <a href="javascript:void(0);" @click="link('/updateinfo')"><p>アップデート情報</p></a>
      </div></a>
    </nav><!-- /spMenuBody-->
  </div><!-- /spMenu-->
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  components: {
  },
  props: [
    'isOpen'
  ],
  data () {
    return {
      isSpecialsOpen: false,
      isArtworksOpen: false,
      isTcc10SenOpen: false,
      isJapan100ViewsOpen: false,
      isMyPreciousOpen: false,
      isArtworkListOpen: false,
      isTalkshowsOpen: false,
      isPhotobookOpen: false
    }
  },
  computed: {
    ...mapGetters([
      'specialExhibitions',
      'specialExhibitionsIndexById',
      'specialExhibitionById',
      'tsvLoadCompleteFlag'
    ]),
    openDialog: {
      get () {
        return this.isOpen
      },
      set (value) {
        this.$emit('update:isOpen', value)
      }
    }
  },
  methods: {
    isDemo () {
      return process.env.VUE_APP_DEMO_HOST ? (location.host.indexOf(process.env.VUE_APP_DEMO_HOST) >= 0) : false
    },
    openMenu (type) {
      if (type === 'specials') {
        this.isSpecialsOpen = !this.isSpecialsOpen
      } else if (type === 'artworks') {
        this.isArtworksOpen = !this.isArtworksOpen
      } else if (type === 'tcc10sen') {
        this.isTcc10SenOpen = !this.isTcc10SenOpen
      } else if (type === 'japan100Views') {
        this.isJapan100ViewsOpen = !this.isJapan100ViewsOpen
      } else if (type === 'myPrecious') {
        this.isMyPreciousOpen = !this.isMyPreciousOpen
      } else if (type === 'artworkList') {
        this.isArtworkListOpen = !this.isArtworkListOpen
      } else if (type === 'talkshows') {
        this.isTalkshowsOpen = !this.isTalkshowsOpen
      } else if (type === 'photobooks') {
        this.isPhotobookOpen = !this.isPhotobookOpen
      }
    },
    link (url) {
      if (location.pathname !== url) {
        this.$router.push(url)
      }
      this.close()
    },
    close () {
      // スクロールの固定を解除
      const ua = window.navigator.userAgent.toLowerCase()
      const isiOS = ua.indexOf('iphone') > -1 || ua.indexOf('ipad') > -1 || (ua.indexOf('macintosh') > -1 && 'ontouchend' in document)
      const body = document.body
      if (isiOS) {
        body.style.removeProperty('position')
        body.style.removeProperty('top')
        // window.scrollTo(0, this.currentScrollPosition)
      } else {
        body.style.removeProperty('overflow')
      }

      this.openDialog = false
    }
  },
  watch: {
    isOpen: function (value) {
      if (value) {
      }
    }
  }
}
</script>

<style scoped>
a {
  color: white;
}

.spMenuDefault {
  position: fixed;
  width: 0px;
  height: 0px;
  top: 0px;
  left: 0px;
  overflow-y: auto;
  opacity: 0;
  z-index: 19999;
  transition: all 0.5s;
}

.modal {
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  opacity: 1;
  z-index: 19999;
}

.menuWrapper {
  overflow: hidden;
  margin-top: 14px;
}

.menuOpen {
  margin-top: 0px;
  transition: all 0.5s;
}
.menuClose {
  margin-top: -420px;
  transition: all 0.5s;
}
</style>
